<template>
  <div style="max-width: 520px;" label-width="160px" @submit.native.prevent>
    <div>

      <!-- <el-form-item label="標題">
        <el-input v-model="form[formKey].Title" @input="$emit('title-changed', form[formKey].Title)"></el-input>
      </el-form-item>

      <el-form-item label="介紹">
        <el-input v-model="form[formKey].Description" type="textarea" autosize></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="連結網址">
        <el-input v-model="form[formKey].Link"></el-input>
      </el-form-item> -->

      <el-form-item>
        <template slot="label">
          電腦版圖片<br>(1080x1080)
        </template>
        <el-upload
          v-loading="isProcessingImagePC"
          ref="pcelupload"
          accept="image/*"
          class="left"
          style="height: 180px;"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genImageFileParamPC())">
          <img
            ref="pcImg"
            v-show="form[formKey].ImageURLX3 || form[formKey]['pcObjectURL']"
            @load="e => onImageLoaded(e, genImageFileParamPC())"
            class="preview"
            :src="form[formKey]['pcObjectURL'] || form[formKey].ImageURLX3"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!form[formKey].ImageURLX3 && !(form[formKey]['pcObjectURL'])" class="el-icon-upload"></i>
          <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <template slot="label">
          手機版圖片<br>(1080x1920)
        </template>
        <el-upload
          v-loading="isProcessingImageMob"
          ref="mobelupload"
          accept="image/*"
          class="left"
          style="height: 180px;"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genImageFileParamMob())">
          <img
            ref="mobImg"
            v-show="form[formKey]['mobObjectURL'] || form[formKey].ImageURLX2"
            @load="e => onImageLoaded(e, genImageFileParamMob())"
            class="preview"
            :src="form[formKey]['mobObjectURL'] || form[formKey].ImageURLX2"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!form[formKey].ImageURLX2 && !(form[formKey]['mobObjectURL'])" class="el-icon-upload"></i>
          <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div>
        </el-upload>
      </el-form-item>
    </div>

  </div>
</template>

<script>
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
export default {
  mixins: [MixinProcessImageFile],
  components: {
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    },
    formKey: {
      default: ''
    }
  },
  data: () => {
    return {
      isProcessingImagePC: false,
      isProcessingImageMob: false
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createNewHomeBanner'
    }
  },
  methods: {
    genImageFileParamPC () {
      let requiredSize = { w: 1080, h: 1080 }
      // 當我們上傳圖片後，
      let params = {
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'pcelupload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'pcImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'pcObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'ImageURLX3',
          'ImageURLX1'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          },
          {
            maxWidth: requiredSize.w / 6,
            maxHeight: requiredSize.h / 6
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'pcImageBlob',
          'thumbImageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `newHomeBanner/${this.form[this.formKey].ID}/image@3x-`
            : `newHomeBanner/image@3x-${this.form[this.formKey].TitleTw}-`,
          this.isEdit
            ? `newHomeBanner/${this.form[this.formKey].ID}/image@1x-`
            : `newHomeBanner/image@1x-${this.form[this.formKey].TitleTw}-`
        ]
      }
      return params
    },
    genImageFileParamMob () {
      let requiredSize = { w: 1080, h: 1920 }
      // 當我們上傳圖片後，
      let params = {
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'mobelupload',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'mobImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'mobObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'ImageURLX2'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'mobImageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `newHomeBanner/${this.form[this.formKey].ID}/image@2x-`
            : `newHomeBanner/image@2x-${this.form[this.formKey].TitleTw}-`
        ]
      }
      return params
    }
  },
  created () {
  }
}
</script>
